import { object, string } from 'yup';

import { noDuplicateNamesSchema } from '../APICredentialsForm.validation';

export function validationSchema(names: string[], isEditing = false) {
  return object().shape({
    name: noDuplicateNamesSchema(names),
    credentials: object()
      .shape({
        username: string().required('Username is required.'),
        personalAccessToken: isEditing
          ? string().notRequired()
          : string().required('Personal Access Token is required'),
      })
      .required(),
  });
}
